import React from 'react';
import styled, { css } from 'styled-components';

const HeroAvatar = ({ className, type, ...props }) => {
  const Component = type === 'button' ? 'button' : 'div';
  return <Component className={className} {...props} type={type === 'button' && type} />;
};

export default styled(HeroAvatar)`
  position: relative;
  width: ${p => p.size || 50}px;
  height: ${p => p.size || 50}px;
  padding: 0;

  &:before {
    content: ' ';
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    background: url(${p => `${p.theme.staticDir}assets/game/ui/heroes/${p.slug}.png`}) center/cover
      no-repeat ${p => p.color};
    transition: transform 0.1s;
    border-radius: 13px;
    z-index: 3;
  }

  ${(p) => {
    if (p.active) {
      return css`
        &:after {
          content: ' ';
          position: absolute;
          left: -2px;
          bottom: -14px
          right: -5px;
          height: 30px;
          border: 2px solid black;
          border-width: 0 5px 0 2px;
          background: ${() => p.theme.modal.background};
          z-index: 2;

          @media (min-width: 768px) {
            bottom: -24px;
            height: 40px;
          }
        }
      `;
    }
    return '';
  }}
`;
